export default function SafetySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
              Is AllChinaBuy Safe? Here Is What You Need to Know
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                Safety is the number one concern for international buyers, and we take it seriously. The <strong>AllChinaBuy Spreadsheet</strong> is designed to minimize risks at every step of your purchasing journey. By only featuring verified sellers with proven track records, we help you avoid scams, counterfeit products, and unreliable shipping.
              </p>
              <p>
                Our comprehensive guides cover secure payment methods, quality control inspections before shipping, shipping insurance options, and detailed seller verification criteria. Every seller in our spreadsheet has been vetted through multiple transactions, and we continuously monitor their performance to ensure consistent quality.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-6">
                {[
                  { icon: 'ri-lock-line', title: 'Secure Payments', desc: 'Use trusted payment methods with buyer protection' },
                  { icon: 'ri-search-eye-line', title: 'QC Inspections', desc: 'Request detailed photos before shipping' },
                  { icon: 'ri-shield-flash-line', title: 'Shipping Insurance', desc: 'Protect your package during transit' },
                  { icon: 'ri-alert-line', title: 'Scam Prevention', desc: 'Tips to identify and avoid unreliable sellers' },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-3 p-4 bg-primary-50/50 rounded-lg border border-primary-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className={item.icon}></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{item.title}</p>
                      <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-md">
            <div className="bg-background-100 rounded-xl p-6 md:p-8">
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-4">Safety Checklist</h3>
              <div className="space-y-3">
                {[
                  'Choose verified sellers with 4.5+ ratings',
                  'Always request QC photos before shipping',
                  'Use agent services for quality inspection',
                  'Select shipping methods with tracking',
                  'Pay through secure platforms with protection',
                  'Review seller feedback from other buyers',
                ].map((tip, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-accent-600 text-xs"></i>
                    </div>
                    <span className="text-sm text-foreground-700">{tip}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}